// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Cayman Islands */
const KY: PhoneNumberData = [1, 'KY', 10, format0, /^(?:345)/];

export default KY;
